export const returnID = (value) =>{
        if(!value)return null;
        const result = value
        const myArray = result.split("-");
        return parseInt(myArray[1], 10)
}

export const returnProperty = (value) =>{
        const result = value
        const myArray = result.split("-");
        return myArray[0]
}

export const reorderArray = (array, fromIndex, toIndex) => {
  const [item] = array.splice(fromIndex, 1);
  array.splice(toIndex, 0, item);
};


/**
 * @param {*} items Tableau contenant des objets javascript contenant une propriété id
 * Exemple ( items = [{id:12, paramètre: value}])
 * @returns 
 */
export const generateUniqueID = (items) =>{
        const ids = items.map((item)=>item.id)
        let id = Math.floor(Math.random() * 1001)

        while (ids.includes(id)) {
                id = Math.floor(Math.random() * 1001)
        }
       
        return id
}


export const dateFormated = (date) => new Date(date).toLocaleDateString("fr");

export const formatDate = (isoDateString) =>{
        // Créer un objet Date à partir de la chaîne ISO
        const date = new Date(isoDateString);

        // Tableau des noms de mois
        const months = [
                'Jan.', 'Fev.', 'Mar.', 'Avr.', 'Mai', 'Juin.',
                'Jui.', 'Août', 'Sep.', 'Oct.', 'Nov.', 'Dec.'
        ];

        // Extraire le jour, le mois et l'année
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();

        // Formater la date
        return `${day} ${month} ${year}`;
}

export const capitalizeFirstLetter=(string)=>(string.charAt(0).toUpperCase() + string.slice(1))
    
  
